export const THUMBNAIL_GENERATOR_ID = 'thumbnail_generator';
